import { ScenarioData } from '../types/scenario';
import { buildApiUrl } from '../config/api';

const API_BASE_URL = buildApiUrl('');

class QuickstartService {
  async getTestScenario(): Promise<ScenarioData> {
    try {
      const response = await fetch(`${API_BASE_URL}/quickstart/test-scenario`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch test scenario: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching test scenario:', error);
      throw error;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async runEnhancedMonteCarlo(scenarioData: any): Promise<any> {
    try {
      // eslint-disable-next-line no-console
      console.log('Sending data to enhanced Monte Carlo:', JSON.stringify(scenarioData, null, 2));
      
      const response = await fetch(`${API_BASE_URL}/api/v1/advanced/monte-carlo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(scenarioData)
      });

      if (!response.ok) {
        const errorText = await response.text();
        // eslint-disable-next-line no-console
        console.error('Enhanced Monte Carlo error response:', errorText);
        throw new Error(`Failed to run Monte Carlo simulation: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error running Monte Carlo simulation:', error);
      throw error;
    }
  }
}

const quickstartService = new QuickstartService();
export default quickstartService; 